export const CRITICAL_CASE_PROPERTIES_REQUEST =
  'CRITICAL_CASE_PROPERTIES_REQUEST'
export const CRITICAL_CASE_PROPERTIES_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_FAIL = 'CRITICAL_CASE_PROPERTIES_FAIL'
export const DETAIL_DATA_CRITICAL_CASE_REQUEST =
  'DETAIL_DATA_CRITICAL_CASE_REQUEST'
export const DETAIL_DATA_CRITICAL_CASE_SUCCESS =
  'DETAIL_DATA_CRITICAL_CASE_SUCCESS'
export const DETAIL_DATA_CRITICAL_CASE_FAIL = 'DETAIL_DATA_CRITICAL_CASE_FAIL'
export const CRITICAL_CASE_PROPERTIES_CLIENT_REQUEST =
  'CRITICAL_CASE_PROPERTIES_CLIENT_REQUEST'
export const CRITICAL_CASE_PROPERTIES_CLIENT_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_CLIENT_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_CLIENT_FAIL =
  'CRITICAL_CASE_PROPERTIES_CLIENT_FAIL'
export const CRITICAL_CASE_PROPERTIES_PATCH_REQUEST =
  'CRITICAL_CASE_PROPERTIES_PATCH_REQUEST'
export const CRITICAL_CASE_PROPERTIES_PATCH_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_PATCH_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_PATCH_FAIL =
  'CRITICAL_CASE_PROPERTIES_PATCH_FAIL'
export const CRITICAL_CASE_PROPERTIES_USER_ENTITIES_REQUEST =
  'CRITICAL_CASE_PROPERTIES_USER_ENTITIES_REQUEST'
export const CRITICAL_CASE_PROPERTIES_USER_ENTITIES_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_USER_ENTITIES_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_USER_ENTITIES_FAIL =
  'CRITICAL_CASE_PROPERTIES_USER_ENTITIES_FAIL'
export const CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_REQUEST =
  'CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_REQUEST'
export const CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_FAIL =
  'CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_FAIL'
export const CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_REQUEST =
  'CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_REQUEST'
export const CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_FAIL =
  'CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_FAIL'
export const CRITICAL_CASE_PROPERTIES_USER_REQUEST =
  'CRITICAL_CASE_PROPERTIES_USER_REQUEST'
export const CRITICAL_CASE_PROPERTIES_USER_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_USER_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_USER_FAIL =
  'CRITICAL_CASE_PROPERTIES_USER_FAIL'
export const CRITICAL_CASE_PROPERTIES_LOCATION_REQUEST =
  'CRITICAL_CASE_PROPERTIES_LOCATION_REQUEST'
export const CRITICAL_CASE_PROPERTIES_LOCATION_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_LOCATION_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_LOCATION_FAIL =
  'CRITICAL_CASE_PROPERTIES_LOCATION_FAIL'
export const CRITICAL_CASE_PROPERTIES_DEPARTMENT_REQUEST =
  'CRITICAL_CASE_PROPERTIES_DEPARTMENT_REQUEST'
export const CRITICAL_CASE_PROPERTIES_DEPARTMENT_SUCCESS =
  'CRITICAL_CASE_PROPERTIES_DEPARTMENT_SUCCESS'
export const CRITICAL_CASE_PROPERTIES_DEPARTMENT_FAIL =
  'CRITICAL_CASE_PROPERTIES_DEPARTMENT_FAIL'
